import React from 'react';

const Blank = () => <span />;

export default Blank;
